module.exports = __webpack_public_path__ + "img/四川外国语大学.531bd08f.png";